import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { TuiLoader } from '@taiga-ui/core';

@Component({
	standalone: true,
	imports: [TuiLoader, TranslocoPipe],
	selector: 'mar-app-loader',
	styleUrl: 'app-loader.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<tui-loader class="z-10 h-36 w-36" size="xxl" />
		@if (text(); as text) {
			<p class="z-10 text-xl">{{ text | transloco }}</p>
		}
	`,
	host: {
		class: 'z-[9999] fixed inset-0 flex h-full w-full items-center justify-center flex-col',
	},
})
export class AppLoaderComponent {
	text = input<string | null>('generic.loading');
}
